function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.11 10.5175C32.76 9.485 31.78 8.75 30.625 8.75H11.375C10.22 8.75 9.2575 9.485 8.89 10.5175L5.25 21V35C5.25 35.9625 6.0375 36.75 7 36.75H8.75C9.7125 36.75 10.5 35.9625 10.5 35V33.25H31.5V35C31.5 35.9625 32.2875 36.75 33.25 36.75H35C35.9625 36.75 36.75 35.9625 36.75 35V21L33.11 10.5175ZM11.9875 12.25H29.995L31.815 17.5H10.1675L11.9875 12.25ZM33.25 29.75H8.75V21H33.25V29.75Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.125 28C14.5747 28 15.75 26.8247 15.75 25.375C15.75 23.9253 14.5747 22.75 13.125 22.75C11.6753 22.75 10.5 23.9253 10.5 25.375C10.5 26.8247 11.6753 28 13.125 28Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.875 28C30.3247 28 31.5 26.8247 31.5 25.375C31.5 23.9253 30.3247 22.75 28.875 22.75C27.4253 22.75 26.25 23.9253 26.25 25.375C26.25 26.8247 27.4253 28 28.875 28Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.625,
  cy: 28.375,
  r: 4.87501,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.5 22C30.3579 22 27 25.3579 27 29.5C27 33.6421 30.3579 37 34.5 37C38.6421 37 42 33.6421 42 29.5C41.9956 25.3597 38.6403 22.0044 34.5 22ZM35.0357 29.5C35.0357 29.7959 34.7959 30.0357 34.5 30.0357H30.2143C29.9184 30.0357 29.6786 29.7959 29.6786 29.5C29.6786 29.2041 29.9184 28.9643 30.2143 28.9643H33.9643V25.2143C33.9643 24.9184 34.2042 24.6786 34.5 24.6786C34.7959 24.6786 35.0357 24.9184 35.0357 25.2143V29.5Z",
  fill: "#FFB946"
});

function SvgCarLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarLock);
export default __webpack_public_path__ + "static/media/car-lock.ada1a9db.svg";
export { ForwardRef as ReactComponent };